export var radioGroupTheme = {
  baseStyle: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingY: 'xxs'
  },
  variants: {
    horizontal: {
      flexDir: {
        xs: 'column',
        s: 'row'
      },
      gridGap: {
        xs: 'xs',
        s: 'm'
      },
      flexWrap: {
        xs: 'nowrap',
        s: 'wrap'
      }
    },
    vertical: {
      gridGap: 's',
      flexDir: 'column',
      alignItems: 'flex-start'
    }
  },
  defaultProps: {
    variant: 'horizontal'
  }
};
//# sourceMappingURL=RadioGroup.theme.js.map